export const BULANDI_EVENT_LOGO_URL = "/pages/bulandi-2026/bulandi-header.png";

export const BUL_HERO_REG_TICKLER_TYPE =
  "font-display text-[0.84375rem] uppercase leading-none tracking-tight sm:text-[0.94921875rem] md:text-[1.0546875rem] lg:text-[1.265625rem] xl:text-[1.40625rem]";

export const BUL_EVENTS_SECTION_HEADING_CLASS =
  "font-display text-[1.265625rem] sm:text-[1.6875rem] md:text-[2.109375rem] uppercase tracking-tight text-bul-fg";
